import { render, staticRenderFns } from "./assignMember.vue?vue&type=template&id=e19b2382"
import script from "./assignMember.vue?vue&type=script&lang=js"
export * from "./assignMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports